shadow$provide[283] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Swizzle:{enumerable:true, get:function() {
  return Swizzle;
}}});
var UGLSL = require("../../../util/glsl.js");
var require$_DOT__SLASH_operator_DOT_js = require("./operator.js");
class Swizzle extends require$_DOT__SLASH_operator_DOT_js.Operator {
  static initClass() {
    this.traits = ["node", "bind", "operator", "source", "index", "swizzle"];
  }
  sourceShader(shader) {
    shader = super.sourceShader(shader);
    if (this.swizzler) {
      shader.pipe(this.swizzler);
    }
    return shader;
  }
  make() {
    super.make();
    if (this.bind.source == null) {
      return;
    }
    const {order} = this.props;
    if (order.join() !== "1234") {
      return this.swizzler = UGLSL.swizzleVec4(order, 4);
    }
  }
  unmake() {
    super.unmake();
    return this.swizzler = null;
  }
  change(changed, touched, _init) {
    if (touched["swizzle"] || touched["operator"]) {
      return this.rebuild();
    }
  }
}
Swizzle.initClass();

};